export default __webpack_public_path__ + "static/media/mobile.19598b4d.gif";